const HeaderNav = (props) => (
    <div className="header-nav">
        {props.children}
        <div className="clear-both"></div>
    </div>
)

export default HeaderNav;